import React, { Component } from 'react'
import shortid from "shortid";
import MyComponent from '../components/MyComponent';

const NewMenuContainer = ({ containerObject, templateName, contentId, dataZone }) => {

  
    return (
        <div className="containerWarp"  data-cont-id={containerObject ? containerObject.contentId : ""} data-zone="ContentFolderZone" data-zone-id="Content Rule Zone" data-page-id={containerObject ? containerObject.containerContentId : ""}>
            <div className="primary-zone" data-zone="ContentFolderZone" >
                <div className={"row m-0 "} data-page-id={containerObject ? containerObject.contentId : ""} data-id="zone" data-zone="ContentFolderZone"
                    plugin-name={containerObject && containerObject.contents && containerObject.contents.ContentFolderZone[0] &&
                        containerObject.contents.ContentFolderZone[0].attributes && containerObject.contents.ContentFolderZone[0].attributes.folderName} >
                    <div className="container-fluid justify-content-around gx-0 px-0"

                        data-page-id={containerObject ? containerObject.contentId : ""} data-id="zone" data-zone="ContentFolderZone">

                        {containerObject && containerObject.contents && containerObject.contents.ContentFolderZone.map(content => {
                            let contentFolderZoneType = content['@type'];

                            return (
                                <div class="row ca-mega-menu-container gx-0">
                                    <div class="col-12">
                                        <nav>
                                            <ul class="ca-nav-list main-menu nav-menu-list">
                                                <MyComponent type={contentFolderZoneType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone={"ContentFolderZone"} templateName={contentFolderZoneType} parentAttributes={containerObject.attributes ? containerObject.attributes : ""} />
                                            </ul> 
                                        </nav>
                                    </div>
                                </div>
                            )
                        }
                        )}
                    </div>
                </div>
            </div>
        </div>

    )

}
export default NewMenuContainer;
